import { Injectable, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import {Training} from "../models/training.model";
import {share} from "rxjs/operators";
import {LocalStorageService} from "../modules/services/localStorage-service/local-storage.service";
import {UserDashboardService} from "../modules/user-dashboard.service";

@Injectable({ providedIn: 'root' })
export class RedirectService {
  private readonly key = 'redirect';

  constructor(private router: Router, private localStorageService: LocalStorageService, private userDashboarService: UserDashboardService) {
    // Listen for storage events from other tabs/windows
    window.addEventListener('storage', (e: StorageEvent) => {
      console.debug('Storage event detected in RedirectService:', e);
      if (e.key === this.key && e.newValue) {
        this.handleRedirect(e.newValue);
      }
    });


  }

  // Call once on app startup
  init(): void {
    setInterval(() => {
      if (this.localStorageService.getItemUnparsed(this.key)) {
        this.handleRedirect(this.localStorageService.getItemUnparsed(this.key));
      }
    }, 200)
    const raw = this.localStorageService.getItemUnparsed(this.key);
    if (raw) {
      this.handleRedirect(raw);
    }
  }

  private async handleRedirect(unitId: string | null): Promise<void> {
    if (!unitId) return;

    localStorage.removeItem(this.key);
    try {
      let training = await this.userDashboarService.fetchUnitTraining(unitId).toPromise();
      this.userDashboarService.fetchRedirectUnit(unitId)

      this.userDashboarService.setTraining(training)
      this.goToTraining(training, unitId)
      setTimeout(() => {
        location.reload();
      }, 500)
    } catch (error) {
      console.error('Error during redirect handling:', error);
      alert('Обука је закључана, биће доступна након што је одгледате у редовној обуци.');
    }

  }

  goToTraining(training: Training, unitId: string) {

    this.localStorageService.setItem("trainingInfo", training);
    this.changeStatus(training, 2)
    this.router.navigateByUrl('user/training', { state: { unitId: unitId } } );

  }


  changeStatus(training: Training, status: Number){
    this.userDashboarService.changeTrainingStatus(training._id, status).subscribe((result)=>{
      console.log(result)
    })
  }
}

